import { MAIN_CONTENT_ID } from '@shared/constants/ContentIdValues';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const ScrollToTop = () => {
    const location = useLocation();

    useEffect(() => {
        setTimeout(() => {
            const contentElement = document.getElementById(MAIN_CONTENT_ID);
            if (contentElement) {
                contentElement.scrollTop = 0;
            } else {
                window.scrollTo(0, 0);
            }
        }, 100); // timeout due to view transitions
    }, [location]);

    return null;
};

export default ScrollToTop;
